<script>
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import { uuid } from 'vue-uuid';



export default {
  mixins: [Api, Sabit],
  props: ["Raporgirisid", "Kontrolgirisid", "Icdegergirisid", "OnayDurumu"],
  data() {
    return {

      file: "",
      uzanti: "",

      uuid: uuid.v4(),


      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      Filter: "",
      TabloVerileri: [],
      TabloDetayVerileri: [],
      FormVeri: {
        Fileurl: "",
        Deleted: false,
        Filename: "",
        Link: "",
        Kontrolgirisid: "",
        Raporgirisid: "",
        IcDegerId: "",
      },
    };
  },

  computed: {

  },
  watch: {
    Kontrolgirisid() {


      this.Get();
    },

    Raporgirisid() {

      this.Get();

    },

    Icdegergirisid() {

      this.Get();

    }


  },


  methods: {
    Get() {

      this.TabloDetayVerileri = [];


      if (this.Raporgirisid != null && this.Raporgirisid != "00000000-0000-0000-0000-000000000000") {

        this.Filter = "&Raporgirisid=" + this.Raporgirisid;
        this.FormVeri.Raporgirisid = this.Raporgirisid;
      }
      else if (this.Kontrolgirisid != null && this.Kontrolgirisid != "00000000-0000-0000-0000-000000000000") {
        this.Filter = "&Kontrolgirisid=" + this.Kontrolgirisid;
        this.FormVeri.Kontrolgirisid = this.Kontrolgirisid;
      }
      else if (this.Icdegergirisid != null && this.Icdegergirisid != "00000000-0000-0000-0000-000000000000") {
        this.Filter = "&IcDegerId=" + this.Icdegergirisid;
        this.FormVeri.IcDegerId = this.Icdegergirisid;
      }
      else { this.Filter = ""; }


      if (this.Filter != "" && this.Filter != null) {

        this.ActionsFilterGet({ Service: "StrKontrolGirisKanit", Page: this.Page, Filter: this.Filter }).then((res) => {
          this.TabloDetayVerileri = res.Data;
          this.Page.PageDataSize = res.TotalCount;
        });

      }


    },
    onSubmit() {


    },

    FileUpload() {
      this.file = this.$refs.file.files[0];
      let x = this.file.name;
      this.FormVeri.Filename = this.file.name;
      this.uzanti = x.substr(x.lastIndexOf('.') + 1, x.length - x.lastIndexOf('.'));


      /* this.FormVeri.Filename=this.File.name;
       let x=this.FormVeri.Filename;
       let isim= x.substr(0, x.lastIndexOf('.'));
       let uzanti=x.substr(x.lastIndexOf('.')+1, x.length-x.lastIndexOf('.'));
       this.uuid= uuid.v4();  
       this.FormVeri.Filename=this.uuid+"."+uzanti;
       console.log(this.FormVeri); */
    },

    submitFile() {

      if (this.file != "" && this.file != null) {

        if (this.uzanti == 'pdf' || this.uzanti == 'png' || this.uzanti == 'jpeg' || this.uzanti == 'jpg'
          || this.uzanti == 'xls' || this.uzanti == 'xlsx' || this.uzanti == 'doc' || this.uzanti == 'docx') {

          let formData = new FormData();

          formData.append('file', this.file);


          this.Post("GenericFileUpDownload/UploadFile?pathUrl=Str", formData).then((res) => {

            if (res) {
              console.log(res)

              this.FormVeri.Fileurl = "Str/" + res.Data.filename;
              this.submit_veri();
            }
          });


        } else {

          this.$toast.error(this.$t('StrKontrolGirisKanit.Alerts.FileTypeControl'));
        }
      } else {
        if (this.FormVeri.Link != "" && this.FormVeri.Link != null) {
          this.submit_veri();
        } else {
          this.$toast.error(this.$t('StrKontrolGirisKanit.Alerts.validate'));
        }
      }
    },

    submit_veri() {

      if (this.Kontrolgirisid != null) {
        this.$delete(this.FormVeri, "Raporgirisid");
        this.$delete(this.FormVeri, "IcDegerId");
      }

      if (this.Raporgirisid != null) {
        this.$delete(this.FormVeri, "Kontrolgirisid");
        this.$delete(this.FormVeri, "IcDegerId");
      }

      if (this.Icdegergirisid != null) {
        this.$delete(this.FormVeri, "Raporgirisid");
        this.$delete(this.FormVeri, "Kontrolgirisid");

      }
      if (this.FormVeri.Link != "" && this.FormVeri.Link != null) {
        this.FormVeri.Filename = "link"
      }

      console.log(this.FormVeri);

      this.Post("StrKontrolGirisKanit", this.FormVeri).then((res) => {
        if (res) {
          this.$emit("TableUpdate");
          this.FormVeri.Filename = "";
          this.FormVeri.Fileurl = "";
          this.FormVeri.Link = "";
          this.file = "";


        }
      });
    },

    indir(file) {
      let dosya_adi = file.substr(4, file.length - 4);

      let Filter = "?fileName=" + dosya_adi + "&pathUrl=Str";

      this.ActionsFileGet({ Service: "GenericFileUpDownload/DownloadFile", Filter }).then((res) => {

        if (res) {

          /*
           var FILE = window.URL.createObjectURL(new Blob([res.Data]));
           
           var docUrl = document.createElement('x');
           docUrl.href = FILE;
           docUrl.setAttribute('download', 'file1.pdf');
           document.body.appendChild(docUrl);
           docUrl.click();
           */


          let blob = new Blob([res])
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = dosya_adi
          link.click()
        }

      });


    },
    KanitDelete(servis, id) {
      this.Delete(servis, id).then((res) => {

        if (res) {

          this.$emit("TableUpdate");
        }

      })
    }



  }
};
</script>
<template>
  <b-modal id="StrKontrolGirisKanit" size="lg" :title="$t('StrKontrolGirisKanit.AddEdit.FormTitle')" title-class="font-18"
    hide-footer>

    <Form @submit.prevent="onSubmit">
      <div class="row">
        <div class="col-md-10">

          <div class="mt-3" v-if="!OnayDurumu">

            <input class="form-control" ref="file" name="sefer" type="file" v-on:change="FileUpload($event)" id="file"
              accept=".jpg, .jpeg, .png, .pdf, .xls, .xlsx, .doc, .docx " />



          </div>

         <b-form-group v-if="!OnayDurumu && Icdegergirisid == null" class="d-block" id="example text" label-cols-lg="4" label="Link"
            label-for="text">


           <div class="col-sm-auto">
              <label for="inlineFormemail2" class="sr-only">Email</label>
              <div role="group" class="input-group mb-3">
                <div class="input-group-prepend">
                  <div class="input-group-text">http://</div>
                </div>
                <b-form-input for="text" v-model="FormVeri.Link" value=""></b-form-input>
              </div>
            </div> 





          </b-form-group>

        </div>
      </div>

      <br>

      <button v-if="!OnayDurumu" class="btn btn-primary"
        v-on:click="submitFile()">{{ $t('StrKontrolGirisKanit.AddEdit.Button') }}</button>


    </Form>
    <hr>

    <div class="table-responsive">
      <table class="table table-striped table-bordered mb-0">
        <tbody>
          <tr>
            <th scope="col">{{ $t('StrKontrolGirisKanit.Table.KanitAdi') }}</th>
            <th scope="col"></th>
            <th scope="col">{{ $t('StrKontrolGirisKanit.Table.Islem') }}</th>
          </tr>
          <tr v-for="Data in TabloDetayVerileri" :key="Data.Id">
            <td>
              <div v-if="Data.Fileurl != '' && Data.Link == ''"> {{ Data.Filename }}</div>
              <div v-if="Data.Link != '' && Data.Fileurl == ''"> <a :href="'http://' + Data.Link"
                  target="blank">{{ Data.Link }}</a></div>
              <div v-if="Data.Link != '' && Data.Fileurl != ''"> {{ Data.Filename }} <br>
                <a :href="'http://' + Data.Link" target="blank">{{ Data.Link }}</a>
              </div>


            </td>
            <td>

              <div v-if="Data.Fileurl != ''">
                <i style="margin-left:10px" @click="indir(Data.Fileurl)" class="fas fa-download">
                </i>
              </div>
            </td>
            <td>
              <i style="margin-left:10px" @click="KanitDelete('StrKontrolGirisKanit', Data.Id)" class="fas fa-trash-alt">
              </i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </b-modal>
</template>
